import axios from "axios";

import {
  getAccessToken,
  getIdToken,
  getRefreshToken,
  logoutUser,
  setSessionCookie,
} from "./SessionManagement";
import { trackEvent } from "src/Amplitude";
import { getRuntimeConfig } from "src/getRuntimeConfig";

// sitting here because this code is shared between userApi and axiosConfig

export const handleGuestConversion = (res: any) => {
  const currentPermission = sessionStorage.getItem("permission");
  const incomingPermission = res.data.permission?.toString();

  if (currentPermission?.includes("guest") && currentPermission !== incomingPermission) {
    trackEvent("User Converted", {}, "Onboarding");
    setSessionCookie("permission", incomingPermission);
    // Send user to portifolio with hard refresh
    window.location.href = "/portfolio";
  }
};
export const refreshAuthLogic = () =>
  axios({
    method: "post",
    url: `${getRuntimeConfig().BASE_URL}${getRuntimeConfig().SUB_PATH}/auth/refreshSession`,
    data: {
      accessToken: getAccessToken(),
      refreshToken: getRefreshToken(),
      idToken: getIdToken(),
    },
  }).then((res: any) => {
    setSessionCookie("id_token", res.data.idToken);
    setSessionCookie("access_token", res.data.accessToken);
    setSessionCookie("refresh_token", res.data.refreshToken);
    handleGuestConversion(res);
    return Promise.resolve();
  });

let isRedirectingToLogin = false;

export const handleError = async (e: any) => {
  // Unauthorized or bad authentication credentials
  if (e.config?.url?.includes("intercom")) return;
  if (e.config?.url?.includes("endSession")) return;
  if (e.config?.url?.includes("login")) return;

  if (e.response?.status === 500) {
    // something happened in backend
    console.log("internal error 500", e.response.data.message);
  } else if (e.response?.status === 401 && !e.response?.data?.message?.includes("2FA")) {
    if (isRedirectingToLogin) return;
    isRedirectingToLogin = true;

    const alreadyOnLoginPage = window.location.pathname === "/";

    if (!e.config?.url?.includes("endSession")) {
      // to avoid infinite loop
      // only log the user out if error was not originated from /endSession
      logoutUser();
    }
    window.sessionStorage.clear();

    // Avoid a reload loop when an unauthenticated API call 401s on the login page
    if (!alreadyOnLoginPage) {
      window.location.replace("/");
    }
  } else if (e.response) {
    console.error(
      `something went wrong when calling ${e.config.url}- tokenRefreshLogin`,
      JSON.stringify(e.response?.data),
    );
  }
};
